"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var getNearestKeyFrames = function getNearestKeyFrames(allKeyFrames, currentFrame) {
  if (!allKeyFrames.length) {
    return {
      leftKeyFrame: null,
      rightKeyFrame: null
    };
  }

  var minFrame = Math.min.apply(Math, (0, _toConsumableArray2["default"])(allKeyFrames));
  var maxFrame = Math.max.apply(Math, (0, _toConsumableArray2["default"])(allKeyFrames));
  var leftKeyFrame = minFrame <= currentFrame ? minFrame : null;
  var rightKeyFrame = maxFrame >= currentFrame ? maxFrame : null;
  allKeyFrames.forEach(function (frame) {
    if (leftKeyFrame !== null && frame <= currentFrame && frame > leftKeyFrame) {
      leftKeyFrame = frame;
    }

    if (rightKeyFrame !== null && frame >= currentFrame && frame < rightKeyFrame) {
      rightKeyFrame = frame;
    }
  });
  return {
    leftKeyFrame: leftKeyFrame,
    rightKeyFrame: rightKeyFrame
  };
};

var _default = getNearestKeyFrames;
exports["default"] = _default;